module.exports = __webpack_public_path__ + "fonts/font02-Italic.f4ed9eee.woff2";